import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { RESULT_TYPE_CONFIG } from '@helpers/order';

export const ResultTypeLegend: React.FC = () => {
  const items = Object.values(RESULT_TYPE_CONFIG).filter(config => config.icon !== undefined);

  return (
    <ul className='fa-ul mb-0'>
      {items.map(resultTypeConfig => (
        <li key={resultTypeConfig.label}>
          <FontAwesomeIcon aria-label={resultTypeConfig.label} icon={resultTypeConfig.icon as IconProp} listItem />{' '}
          {resultTypeConfig.label}
        </li>
      ))}
    </ul>
  );
};
